// document.addEventListener('DOMContentLoaded', function () {
//   const variantMeta = JSON.parse(document.getElementById('VariantMeta')?.textContent || '[]');
//   const purchasedSkus = JSON.parse(document.getElementById('customerPurchasedSkus')?.dataset.value || '[]');
//   const selectedVariantJSON = document.querySelector('[data-selected-variant]')?.textContent;

//   if (!selectedVariantJSON) return;

//   const variant = JSON.parse(selectedVariantJSON);
//   const variantData = variantMeta.find(v => v.id === variant.id);

//   if (variantData && variantData.limit > 0) {
//     const purchasedCount = purchasedSkus.filter(sku => sku === variantData.sku).length;
//     if (purchasedCount >= variantData.limit) {
//       const limitText = `こちらの商品はすでに購入済みです\n（お一人様上限 ${variantData.limit} 点）`;

//       const productForm = document.querySelector('product-form');
//       if (productForm?.toggleSubmitButton) {
//         productForm.toggleSubmitButton(true, limitText);
//       }
//     }
//   }
// });

document.addEventListener('DOMContentLoaded', function () {
  const variantMeta = JSON.parse(document.getElementById('VariantMeta')?.textContent || '[]');
  const purchasedSkus = JSON.parse(document.getElementById('customerPurchasedSkus')?.dataset.value || '[]');

  const selectedVariantJSON = document.querySelector('[data-selected-variant]')?.textContent;
  const productForm = document.querySelector('product-form');

  if (!productForm) return;

  // ▼ バリエーション商品（variantMeta経由）
  if (selectedVariantJSON && variantMeta.length > 0) {
    const variant = JSON.parse(selectedVariantJSON);
    const variantData = variantMeta.find(v => v.id === variant.id);

    if (variantData && variantData.limit > 0) {
      const purchasedCount = purchasedSkus.filter(sku => sku === variantData.sku).length;
      if (purchasedCount >= variantData.limit) {
        const limitText = `こちらの商品はすでに購入済みです\n（お一人様上限 ${variantData.limit} 点）`;
        if (productForm?.toggleSubmitButton) {
          productForm.toggleSubmitButton(true, limitText);
        }
      }
    }
    return; // variant の処理だけで終わる
  }

  // ▼ バリエーションなし商品の処理
  const sku = productForm.dataset.sku;
  const limit = parseInt(productForm.dataset.limit, 10);

  if (sku && limit > 0) {
    const purchasedCount = purchasedSkus.filter(s => s === sku).length;
    if (purchasedCount >= limit) {
      const limitText = `こちらの商品はすでに購入済みです\n（お一人様上限 ${limit} 点）`;
      if (productForm?.toggleSubmitButton) {
        productForm.toggleSubmitButton(true, limitText);
      }
    }
  }
});